export default __webpack_public_path__ + "static/media/error.f3602d7d.png";